import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Ornament } from './Ornament';
const costs = ['Hours spent searching for combinations, exercises and class ideas.', 'Repeating the same material because there was no time to prepare something new.', 'Students learning movements without understanding the progression behind them.', 'Partnerwork becoming confusing because connection, timing and transitions are introduced too quickly.', 'Mixed-level classes that are difficult to organize.', 'Lessons that feel disconnected from one week to the next.', 'More time planning and less time actually teaching.', 'Walking into class with ideas instead of a complete structure.'];
export function PainPoints() {
  return <section className="bg-cream px-4 py-20 sm:py-28" data-id="element-190" data-mp="1t0hoza3r73mz">
      <div className="mx-auto max-w-3xl" data-id="element-191" data-mp="3iew9tjbni6d7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-192" data-mp="3ibrw9vcapy9v">
          <h2 className="text-3xl font-semibold text-ink sm:text-4xl" data-id="element-193" data-mp="1u0sp0t5b8419">
            Does this sound <span className="italic text-burgundy" data-id="element-194" data-mp="27rxe51b1xdxc">familiar?</span>
          </h2>
          <Ornament className="mt-5" data-id="element-195" data-mp="23qvfomoyl5wf" />
          <div className="mt-8 rounded-xl border border-gold/25 bg-white p-6 text-left text-base leading-7 text-ink-muted shadow-soft sm:p-8" data-id="element-196" data-mp="23rx0vjzov8rv">
            <p className="font-display text-xl font-semibold text-ink" data-id="element-197" data-mp="1b2zjrk77ri0p">
              Another Salsa or Bachata class is coming.
            </p>
            <p className="mt-4" data-id="element-198" data-mp="1p3aamn8iwwlv">
              And instead of already knowing exactly what you are going to
              teach, you are searching through saved videos, old notes, social
              media posts and random combinations trying to build something
              that actually feels like a complete class.
            </p>
            <p className="mt-4" data-id="element-199" data-mp="2vkxg2y4024db">
              <strong className="font-semibold text-ink" data-id="element-200" data-mp="1t5oiwxoow7xb">
                Not because you do not know how to dance.
                <br data-id="element-201" data-mp="1y36ukvu3d190" />
                Not because you do not know how to teach.
              </strong>
            </p>
            <p className="mt-4" data-id="element-202" data-mp="226cxpulwqcb9">
              But because turning everything you know into structured,
              progressive and professional classes week after week takes time.
            </p>
          </div>
        </motion.div>

        <div className="mt-14" data-id="element-203" data-mp="1acuf8zwio28e">
          <h3 className="text-center text-2xl font-semibold text-ink" data-id="element-204" data-mp="1efha79ohi39t">
            And every time you start from zero, the same problems appear:
          </h3>
          <ul className="mt-7 space-y-3" data-id="element-205" data-mp="1jdiprkmpbkgj">
            {costs.map((cost, index) => <motion.li key={cost} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04
          }} className="flex items-start gap-3 rounded-lg border border-gold/20 bg-beige/50 px-5 py-4 text-sm leading-6 text-ink" data-id="element-206" data-mp="1o853vvk63r4b" data-mpi={index}>
                <XIcon size={17} className="mt-0.5 shrink-0 text-burgundy" aria-hidden="true" data-id="element-207" data-mp="j5ce2xqdpzkd" />
                {cost}
              </motion.li>)}
          </ul>
          <div className="mt-12 border-t border-gold/40 pt-8 text-center" data-id="element-208" data-mp="57ntzs44ywgd">
            <p className="font-display text-3xl font-semibold text-ink" data-id="element-209" data-mp="gxl44wi4bgx">
              Your knowledge is <span className="italic text-burgundy" data-id="element-210" data-mp="3rmyri05iugw8">already there.</span>
            </p>
            <p className="mx-auto mt-3 max-w-xl text-lg font-medium text-ink-muted" data-id="element-211" data-mp="3rkmd1wyz2onx">
              What you need is a system that helps you organize it, teach it
              and progress it faster.
            </p>
          </div>
        </div>
      </div>
    </section>;
}